import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Avatar,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  TextField,
  CircularProgress,
  useMediaQuery,
  TablePagination,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import PaySlipDoc from "../PaySlipDocument/DocPaySlip";
import swal from "sweetalert2"; // Ensure swal is imported
import { GlobalStyles } from "@mui/system";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from "../../../AuthProvider";

function EmployeePaySlip() {
  const [employees, setEmployees] = useState([]);
  const [saving, setSaving] = useState(false); // State for loading
  const [open, setOpen] = useState(false);
  const [employeePaySlipId, setEmployeePaySlipId] = useState("");
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [paySlipData, setPaySlipData] = useState(null); // State for holding pay slip data
  const [openEditModal, setOpenEditModal] = useState(false); // State to manage edit modal
  const [, setSelectedEmployee] = useState(null); // State for selected employee
  const [editableEmployee, setEditableEmployee] = useState(null); // State for the employee being edited
  const [loader, setLoader] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading, setLoading] = useState(false);
  const { organizationId } = useAuth();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const { oId ,pId} = useAuth();

  const isMobile = useMediaQuery("(max-width:600px)");

  const navigate = useNavigate();

  const fetchEmployees = useCallback(async () => {
    try {
      setLoader(true);
      const response = await fetch(`${baseUrl}/api/employee/getAll/${oId}/${pId}`);
      if (!response.ok) {
        throw new Error("Failed to fetch");
      }
      const data = await response.json();
      const employeesWithImages = data.map((employee) => ({
        ...employee,
        profilePic: `data:image/jpeg;base64,${employee.profilePic}`,
      }));
      setEmployees(employeesWithImages);
    } catch (error) {
      console.error("Error fetching employees:", error);
    } finally {
      setLoader(false); // Hide loader
    }
  }, [page, rowsPerPage]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    fetchEmployees();
  }, [fetchEmployees]);

  const fetchPaySlipData = async () => {
    try {
      // Format the month as "09"
      const formattedMonth = (selectedMonth + 1).toString().padStart(2, "0");
      const response = await fetch(
        `${baseUrl}/api/payslip/getPayslip/${employeePaySlipId}/${formattedMonth}/${selectedYear}/${pId}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch pay slip data");
      }
      const data = await response.json();
      setPaySlipData(data); // Set fetched data to state
      console.log("payslip data :" + data);
    } catch (error) {
      console.error("Error fetching pay slip data:", error);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedEmployee(null);
    setPaySlipData(null); // Clear pay slip data when modal is closed
  };

  const handleClickOpen = (employee) => {
    console.log("payslipId :" + employee.employeeId);
    setSelectedEmployee(employee);
    setEmployeePaySlipId(employee.employeeId); // Set the pay slip ID
    setOpen(true);
  };

  const handleGetData = async () => {
    setLoading(true); // Start loading
    try {
      await fetchPaySlipData(); // Fetch data when the button is clicked
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Stop loading after data is fetched
    }
  };

  const handleEditClick = (employee) => {
    setEditableEmployee(employee);
    setOpenEditModal(true);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditableEmployee((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // const handleSave = async () => {
  //   try {
  //     setSaving(false); // Stop loading
  //     // Create a FormData object
  //     const formData = new FormData();

  //     // Manually append each required field to FormData
  //     formData.append("bonus", editableEmployee.bonus || 0);
  //     formData.append("otherEarnings", editableEmployee.otherEarnings || 0);
  //     formData.append("workBasisPay", editableEmployee.workBasisPay || 0);
  //     formData.append("overTime", editableEmployee.overTime || 0);
  //     formData.append("incentive", editableEmployee.incentive || 0);
  //     formData.append("tax", editableEmployee.tax || 0);
  //     formData.append("pf", editableEmployee.pf || 0);
  //     formData.append("loanRepayment", editableEmployee.loanRepayment || 0);
  //     formData.append(
  //       "earlyLeavingFine",
  //       editableEmployee.earlyLeavingFine || 0
  //     );
  //     formData.append("lateComingFine", editableEmployee.lateComingFine || 0);
  //     formData.append("otherDeductions", editableEmployee.otherDeductions || 0);
  //     formData.append("hra", editableEmployee.hra || 0);
  //     formData.append("dra", editableEmployee.dra || 0);
  //     formData.append("petrolAllowance", editableEmployee.petrolAllowance || 0);
  //     formData.append("foodAllowance", editableEmployee.foodAllowance || 0);
  //     formData.append("basicSalary", editableEmployee.basicSalary || 0);

  //     // Send the PUT request to update employee data
  //     const response = await fetch(
  //       `${baseUrl}/api/employee/salary/update/${editableEmployee.empId}`,
  //       {
  //         method: "PUT",
  //         body: formData, // Send FormData as the request body
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error("Failed to update employee data");
  //     }

  //     // Show SweetAlert success message
  //     swal.fire({
  //       title: "Success!",
  //       text: "Salary BreakDown Data Updated Successfully",
  //       icon: "success",
  //       confirmButtonText: "OK",
  //     });

  //     setOpenEditModal(false);
  //     fetchEmployees(); // Refresh employee data
  //   } catch (error) {
  //     console.error("Error updating employee data:", error);

  //     // Show SweetAlert error message
  //     swal.fire({
  //       title: "Error!",
  //       text: "Failed to update employee data",
  //       icon: "error",
  //       confirmButtonText: "OK",
  //     });
  //   }
  //   setSaving(false); // Stop loading
  // };

  const handleSave = async () => {
    try {
      // Create a FormData object
      const formData = new FormData();
  
      // Manually append each required field to FormData
      formData.append("bonus", editableEmployee.bonus || 0);
      formData.append("otherEarnings", editableEmployee.otherEarnings || 0);
      formData.append("overTime", editableEmployee.overTime || 0);
      formData.append("incentive", editableEmployee.incentive || 0);
      formData.append("tax", editableEmployee.tax || 0);
      formData.append("pf", editableEmployee.pf || 0);
      formData.append("loanRepayment", editableEmployee.loanRepayment || 0);
      formData.append("earlyLeavingFine", editableEmployee.earlyLeavingFine || 0);
      formData.append("lateComingFine", editableEmployee.lateComingFine || 0);
      formData.append("otherDeductions", editableEmployee.otherDeductions || 0);
  
      // Send the PUT request to update employee data
      const response = await fetch(
        `${baseUrl}/api/employee/salary/update/${editableEmployee.empId}`,
        {
          method: "PUT",
          body: formData, // Send FormData as the request body
        }
      );
  
      if (!response.ok) {
        throw new Error("Failed to update employee data");
      }
  
      // Show toast success message
      toast.success("Salary BreakDown Data Updated Successfully", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
  
      setOpenEditModal(false);
      fetchEmployees(); // Refresh employee data
    } catch (error) {
      console.error("Error updating employee data:", error);
  
      // Show toast error message
      toast.error("Failed to update employee data", {
        position: "top-right",
        autoClose: 1000,
       
      });
    }
  };
  

  // const handleClickAttendanceOpen = (employee) => {
  //   navigate(`/EmployeeAttendanceDetails/${employee.empId}`);
  // };
  const handleClickAttendanceOpen = (employee) => {
    navigate(`/EmployeeAttendanceDetails/${employee.empId}/${employee.employeeId}`);
  };
  

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box>
      <Box mt={11} marginLeft={2} marginRight={2}>
        <Card
          sx={{
            backgroundColor: "white",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
          }}
        >
          <CardContent>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              mb={2}
            >
              <Typography variant="h5" sx={{ fontSize: 24, marginBottom: 2 }}>
                <strong>Employees Payroll</strong>
              </Typography>
            </Box>

            <GlobalStyles
              styles={{
                ".custom-sidebar-scrollbar": {
                  scrollbarWidth: "thin", // For Firefox
                  scrollbarColor: "grey #e0e0e0",
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                  width: "6px", // For WebKit-based browsers
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                  background: "#f1f1f1", // Track color
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                  backgroundColor: "grey", // Thumb color
                  borderRadius: "10px",
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                  backgroundColor: "#555",
                },
              }}
            />

            <TableContainer
              component={Paper}
              style={{ maxHeight: "700px", overflowY: "auto" }}
              className="custom-sidebar-scrollbar"
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow sx={{ height: "30px" }}>
                    {[
                      "S.No",
                      // "Thumbnail",
                      "Employee ID",
                      "Employee Name",
                      "Mobile",
                      "E-mail",
                      "Attendance",
                      "Action",
                      "Salary",
                    ].map((header) => (
                      <TableCell
                        key={header}
                        sx={{
                          padding: "2px",
                          height: "30px",
                          textAlign: "center",
                          backgroundColor: "#fff9c4",
                          fontWeight: "Bold",
                          border: "1px solid #ddd",
                          fontSize:'14px'
                        }}

                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loader ? (
                    <TableRow>
                      <TableCell
                        colSpan={9}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                        >
                          <CircularProgress />
                          <Typography variant="body2" sx={{ mt: 1 }}>
                            Loading Data...
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : employees.length === 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={9}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        No data available
                      </TableCell>
                    </TableRow>
                  ) : (
                    employees.map((employee, index) => (
                      <TableRow key={employee.id} sx={{ height: "30px" }}>
                        <TableCell
                          sx={{
                            padding: "2px",
                            height: "30px",
                            border: "1px solid #ddd",
                            textAlign: "center",
                          }}
                        >
                          {index + 1}
                        </TableCell>

                        {/* <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            textAlign: "center",
                            padding: "2px",
                            maxWidth: "50px", // Reduce width
                            minWidth: "50px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Avatar
                              alt={employee.firstName}
                              src={employee.profilePic}
                              sx={{ width: 20, height: 20 }}
                            />
                          </Box>
                        </TableCell> */}
                        <TableCell
                          sx={{
                            padding: "2px",
                            height: "30px",
                            border: "1px solid #ddd",
                            textAlign: "center",
                          }}
                        >
                          {employee.employeeId}
                        </TableCell>
                        <TableCell
                          sx={{
                            padding: "2px",
                            height: "30px",
                            border: "1px solid #ddd",
                            textAlign: "center",
                          }}
                        >
                          {employee.firstName} {employee.lastName}
                        </TableCell>
                        <TableCell
                          sx={{
                            padding: "2px",
                            height: "30px",
                            border: "1px solid #ddd",
                            textAlign: "center",
                          }}
                        >
                          {employee.contactNumber1}
                        </TableCell>
                        <TableCell
                          sx={{
                            padding: "2px",
                            height: "30px",
                            border: "1px solid #ddd",
                            textAlign: "center",
                          }}
                        >
                          {employee.emailId || "N/A"}
                        </TableCell>

                        <TableCell
                       
                          sx={{
                            border: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "80px",
                            minWidth: "80px",
                          }}
                        >
                          
                          <Button
                        
                            sx={{
                              backgroundColor: "#3C3972",
                              margin: "4px",
                              color:'#fff',
                              fontSize: "0.6rem", // Reduce button font size
                              "&:hover": {
                                backgroundColor: "#3C3972",
                              },
                              fontWeight:'bold'
                            }}
                            onClick={() => handleClickAttendanceOpen(employee)}
                          >
                            Attendance
                          </Button>
                        </TableCell>
                        <TableCell
                          sx={{
                            padding: "2px",
                            height: "30px",
                            border: "1px solid #ddd",
                            textAlign: "center",

                          }}
                        >
                          <Button
                            sx={{
                              backgroundColor: "#3C3972",
                              color: "white",
                              fontSize: "0.6rem",
                              fontWeight:'bold',
                              height: "25px",
                              "&:hover": { backgroundColor: "#3C3972" },
                            }}

                            onClick={() => handleClickOpen(employee)}
                          >
                            View PaySlip
                          </Button>
                        </TableCell>
                        <TableCell
                          sx={{
                            padding: "2px",
                            height: "30px",
                            border: "1px solid #ddd",
                            textAlign: "center",
                          }}
                        >
                          <Button
                            sx={{
                              backgroundColor: "#3C3972",
                              color: "white",
                              fontSize: "0.6rem",
                              height: "25px",
                              fontWeight:'bold',
                              "&:hover": { backgroundColor: "#3C3972" },
                            }}
                            onClick={() => handleEditClick(employee)}
                          >
                            SB
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Box>

      <Dialog open={open} onClose={handleClose}  maxWidth="lg">
        <DialogTitle style={{ fontWeight: "bold", fontSize: "20px" }}>
          Employee Monthly PaySlip
        </DialogTitle>
        <DialogContent>
          <Box>
            <FormControl fullWidth margin="normal">
              <InputLabel>Month</InputLabel>
              <Select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                label="Month"
              >
                {Array.from({ length: 12 }, (_, i) => (
                  <MenuItem key={i} value={i}>
                    {new Date(0, i).toLocaleString("default", {
                      month: "long",
                    })}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth margin="normal">
              <InputLabel>Year</InputLabel>
              <Select
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
                label="Year"
              >
                {[2024, 2025].map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Button
              variant="contained"
              onClick={handleGetData}
              sx={{
                marginTop: "16px",
                minWidth: "120px", // Ensures the button doesn't shrink
                height: "40px", // Sets a height for alignment
                backgroundColor:'#3C3972',
                "&:hover": { backgroundColor: "#3C3972" },
              }}
              disabled={loading} // Disables the button when loading
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Get PAYSLIP"
              )}
            </Button>
          </Box>
          {paySlipData && (
            <PaySlipDoc
              data={paySlipData} // Pass the fetched data
              employeePaySlipId={employeePaySlipId}
              month={selectedMonth.toString().padStart(2, "0")} // Format month as "09"
              year={selectedYear}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="primary"
            variant="contained"
            style={{
              backgroundColor: "#3C3972",
              color: "#fff",

              border: "none",
              borderRadius: "5px",
              marginTop: "30px",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openEditModal}
        onClose={() => setOpenEditModal(false)}
        maxWidth="sm"
      >
        <DialogTitle style={{fontWeight:'bold',fontSize:'20px'}}>Edit Employee Salary Breakdown Form</DialogTitle>
        <DialogContent>
          {editableEmployee && (
            <Box>
              <Grid container spacing={2}>
                {/* <Grid item xs={6}>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Basic Salary"
                    name="basicSalary"
                    value={editableEmployee.basicSalary}
                    onChange={handleEditChange}
                  />
                </Grid> */}
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Bonus"
                    name="bonus"
                    value={editableEmployee.bonus}
                    onChange={handleEditChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Other Earnings"
                    name="otherEarnings"
                    value={editableEmployee.otherEarnings}
                    onChange={handleEditChange}
                  />
                </Grid>
                {/* <Grid item xs={6}>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Work Basis Pay"
                    name="workBasisPay"
                    value={editableEmployee.workBasisPay}
                    onChange={handleEditChange}
                  />
                </Grid> */}
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Incentive"
                    name="incentive"
                    value={editableEmployee.incentive}
                    onChange={handleEditChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Over Time"
                    name="overTime"
                    value={editableEmployee.overTime}
                    onChange={handleEditChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Tax"
                    name="tax"
                    value={editableEmployee.tax}
                    onChange={handleEditChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="PF"
                    name="pf"
                    value={editableEmployee.pf}
                    onChange={handleEditChange}
                  />
                </Grid>
                {/* <Grid item xs={6}>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="HRA"
                    name="hra"
                    value={editableEmployee.hra}
                    onChange={handleEditChange}
                  />
                </Grid> */}
                {/* <Grid item xs={6}>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="DRA"
                    name="dra"
                    value={editableEmployee.dra}
                    onChange={handleEditChange}
                  />
                </Grid> */}
                {/* <Grid item xs={6}>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Food Allowance"
                    name="foodAllowance"
                    value={editableEmployee.foodAllowance}
                    onChange={handleEditChange}
                  />
                </Grid> */}
                {/* <Grid item xs={6}>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Petrol Allowance"
                    name="petrolAllowance"
                    value={editableEmployee.petrolAllowance}
                    onChange={handleEditChange}
                  />
                </Grid> */}
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Other Deductions"
                    name="otherDeductions"
                    value={editableEmployee.otherDeductions}
                    onChange={handleEditChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Late Coming Fine"
                    name="lateComingFine"
                    value={editableEmployee.lateComingFine}
                    onChange={handleEditChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Early Leaving Fine"
                    name="earlyLeavingFine"
                    value={editableEmployee.earlyLeavingFine}
                    onChange={handleEditChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Loan Repayment"
                    name="loanRepayment"
                    value={editableEmployee.loanRepayment}
                    onChange={handleEditChange}
                  />
                </Grid>
              </Grid>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
        <Button
            onClick={() => setOpenEditModal(false)}
            // color="primary"
            variant="outlined"
            // style={{
            //   backgroundColor: "black",
            //   color: "#fff",
            //   borderRadius: "5px",
            // }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            color="primary"
            variant="outlined"
            style={{
              backgroundColor: "#3C3972",
              color: "#fff",
              borderRadius: "5px",
            }}
          >
            Save
          </Button>
          
        </DialogActions>
      </Dialog>

            <ToastContainer/>
    </Box>
  );
}

export default EmployeePaySlip;